import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { HourReportWorkflow } from "../../api"
import { MaterialSymbol } from "../hour-reporting-roles/components/MaterialSymbol"
import WorkflowRequirementChip from "./WorkflowRequirementChip"
import { useHourReportWorkflowTranslations } from "./use-translations"

type HourReportReviewProcessProps = {
  workflow: HourReportWorkflow
  reviewRequiresSubmission: boolean
  approvalRequiresChecking: boolean
}

const HourReportReviewProcess = ({
  workflow,
  reviewRequiresSubmission,
  approvalRequiresChecking,
}: HourReportReviewProcessProps) => {
  const translations = useHourReportWorkflowTranslations()
  const steps = [
    { label: translations.reporterReports },
    { label: translations.reporterMarksReportReady, required: reviewRequiresSubmission },
    ...(workflow === HourReportWorkflow.CheckAndApproval
      ? [{ label: translations.checkerChecksReport, required: approvalRequiresChecking }]
      : []),
    { label: translations.approverApprovesReport },
  ]

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {steps.map((step, index) => (
        <Box key={step.label} display="flex" flexDirection="column" alignItems="center" width="100%">
          {index > 0 && (
            <Box my={0.5} display="flex" color="text.secondary">
              <MaterialSymbol name="arrow_downward" aria-hidden="true" style={{ fontSize: 20 }} />
            </Box>
          )}
          <Box
            border={1}
            borderColor="divider"
            borderRadius={4}
            px={2}
            height={60}
            width={440}
            maxWidth="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            bgcolor="background.paper"
            style={{ boxSizing: "border-box" }}
          >
            {step.required !== undefined && (
              <Box mb={0.5}>
                <WorkflowRequirementChip required={step.required} />
              </Box>
            )}
            <Typography variant="subtitle2">{step.label}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default HourReportReviewProcess
